import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';

export const HoldersModal = ({ holdersFor, setHoldersFor, formatCurrency }) => (
  <Dialog open={!!holdersFor} onOpenChange={() => setHoldersFor(null)}>
    <DialogContent className="bg-[#0A0A0A] border-[#262626] max-w-lg max-h-[80vh] overflow-y-auto" data-testid="holders-modal">
      <DialogHeader><DialogTitle className="font-serif text-white">Fraction Holders</DialogTitle></DialogHeader>
      {holdersFor && (
        <div className="space-y-4">
          <div className="p-3 bg-[#0F0F0F] border border-[#1A1A1A] rounded">
            <p className="text-white text-sm font-medium">{holdersFor.asset_name}</p>
            <p className="text-[11px] text-muted-foreground">
              {holdersFor.holder_count} {holdersFor.holder_count === 1 ? 'holder' : 'holders'} ·
              {' '}{holdersFor.fractions_sold.toLocaleString()} of {holdersFor.total_fractions.toLocaleString()} fractions sold ({holdersFor.sold_percent.toFixed(1)}%)
            </p>
          </div>
          {holdersFor.holders.length === 0 ? (
            <p className="text-xs text-muted-foreground italic text-center py-6">
              No one has bought fractions of this asset yet. {holdersFor.status !== 'listed' && '(List it on the marketplace to start receiving buyers.)'}
            </p>
          ) : (
            <div className="space-y-2">
              {holdersFor.holders.map((h, idx) => (
                <div key={h.user_id} className="flex items-center gap-3 p-3 bg-[#0F0F0F] border border-[#1A1A1A] rounded" data-testid={`holder-${h.user_id}`}>
                  <div className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-semibold flex-shrink-0 ${
                    idx === 0 ? 'bg-gold text-black' :
                    idx === 1 ? 'bg-zinc-300 text-black' :
                    idx === 2 ? 'bg-amber-700 text-white' :
                    'bg-[#1A1A1A] text-muted-foreground'
                  }`}>{idx + 1}</div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm text-white truncate">{h.name}</p>
                    <p className="text-[10px] text-muted-foreground">{h.fractions.toLocaleString()} fractions · {h.ownership_percent}% ownership</p>
                  </div>
                  <p className="text-gold text-sm font-semibold whitespace-nowrap">{formatCurrency(h.value)}</p>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </DialogContent>
  </Dialog>
);
